import { Icon } from '../components/icons';

// WorkflowSteps: Schrittleiste des Akquise-Arbeitsplatzes (Lead → Gespräch → Ergebnis → Erledigt); current = Index des
// aktuellen Schritts, frühere Schritte gelten als erledigt.
export function WorkflowSteps({ steps, current }: { steps: string[]; current: number }) {
  return (
    <ol className="workflow-steps" aria-label="Arbeitsschritte">
      {steps.map((label, i) => {
        const state = i < current ? 'done' : i === current ? 'current' : 'todo';
        return (
          <li key={label} className={`workflow-step ${state}`} aria-current={state === 'current' ? 'step' : undefined}>
            <span className="workflow-step-mark" aria-hidden="true">
              {state === 'done' ? <Icon name="check" size={14} /> : i + 1}
            </span>
            <span className="workflow-step-label">{label}</span>
            {state === 'done' && <span className="visually-hidden"> (erledigt)</span>}
          </li>
        );
      })}
    </ol>
  );
}

// Shortcuts: sichtbare Tastenkürzel des aktuellen Schritts.
export function Shortcuts({ keys }: { keys: [string, string][] }) {
  if (keys.length === 0) return null;
  return (
    <p className="shortcuts" aria-label="Tastenkürzel">
      <span className="muted">Tastenkürzel:</span>
      {keys.map(([k, label]) => (
        <span key={k} className="shortcut">
          <kbd>{k}</kbd> {label}
        </span>
      ))}
    </p>
  );
}
